import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { RatioOptions, UndefinedOption } from '@df/ui/atomic/atomic-options';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsVideo {
    export interface IComponentData extends NICmsContentComponent.IData {
        ratio: string;
        videoProvider?: 'youtube' | 'vimeo';
        videoId: string;
        videoAutoplay: boolean;
        videoBackground: boolean;
        backgroundImage?: string;
    }
}

@ICmsComponent<CmsVideoComponent>({
    id: 'video',
    name: 'Video',
    image: '/common/cms/video-component.png',
    tags: ['video', 'image', 'big', 'banner'],
    isAdvanced: true,
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-video',
            title: 'Video'
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-2-1',
            required: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'videoProvider',
            type: NICmsContentField.EFieldType.choice,
            title: 'Video Provider',
            options: [
                ...UndefinedOption,
                {
                    key: 'youtube',
                    title: 'YouTube'
                },
                {
                    key: 'vimeo',
                    title: 'Vimeo'
                }
            ],
            description: 'Choose a video provider'
        },
        {
            key: 'videoId',
            type: NICmsContentField.EFieldType.text,
            title: 'ID or URL',
            description: 'Video ID or URL',
            default: '',
            required: true
        },
        {
            key: 'videoBackground',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Background Mode',
            default: true,
            required: true
        },
        {
            key: 'videoAutoplay',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Autoplay',
            default: true,
            required: true,
            canShow: (data: NCmsVideo.IComponentData) => !data.videoBackground
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-image',
            title: 'Background image'
        },
        {
            key: 'backgroundImage',
            type: NICmsContentField.EFieldType.image,
            title: 'Background image',
            default: undefined
        }
    ],
    priority: 40
})
@Component({
    selector: 'cms-video',
    templateUrl: './cms-video.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsVideoComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsVideo.IComponentData;
}
